import React, { useEffect, useState } from "react";
import { inject, observer } from "mobx-react";
import { withRouter } from "react-router-dom";
import Container from "reactstrap/lib/Container";
import withDefaultParams from "Services/withDefaultParams";
import TagButtonComponent from "Containers/TagButtonComponent";
import AntiFilterContainer from "Containers/AntiFilter/AntiFilterContainer";
import { PaddingBottom } from "ComponentsUI/Spacings";
import { StubOperatorTariffs } from "ComponentsUI/Stub";
import { useGetMobileTagsQuery } from "hooks/mobileQueries";
import { Tariffs } from "./Tariffs";
import { EmptyStubWrapper } from "ComponentsUI/EmptyStub";
import Metrika from "Services/Metrika";
import { YANDEX_TARGETS } from "Constants/metriks/yandex-targets";
import { ToogleRatesMobile } from "ComponentsUI/Toggle";
import { isMainSiteCode } from "Utils/siteConfig";

const Page = (props) => {
	const {
		ApplicationModel: {
			text,
			commonViewModel,
			siteConfig: {
				settings: { mobile_tariffs_mode = "list" },
			},
		},
	} = props;

	useEffect(() => {
		Metrika.getInstance().yandex.sendEvent(YANDEX_TARGETS.OPEN_RATESMOBILE_REGION, []);
	}, [props.match.params.tagCode]);

	// Закрыть модальное окно, если оно открыто во время перехода на данную страницу
	useEffect(() => {
		const modal = props.ApplicationModel.modalModel;
		if (modal.isOpen) {
			modal.toggleModal();
		}
	}, [props.match.url]);

	return (
		<PaddingBottom>
			<ToogleRatesMobile
				commonViewModel={commonViewModel}
				page={commonViewModel.ratesMobilePage}
				text={text}
				mobileTariffsMode={mobile_tariffs_mode}
			/>
			{commonViewModel.ratesMobilePage.includes("antifilter") && <AntiFilterContainer />}
			{commonViewModel.ratesMobilePage.includes("list") && (
				<OldPage ApplicationModel={props.ApplicationModel} match={props.match} />
			)}
		</PaddingBottom>
	);
};

export default withRouter(withDefaultParams(inject("ApplicationModel")(observer(Page))));

const OldPage = (props) => {
	const {
		ApplicationModel: { text, siteCode },
		match: { params },
	} = props;

	const providerInetTvMobile = { name: text.INTERNET_TV_MOBILE };
	const providerInetMobile = { name: text.INTERNET_MOBILE };

	const { mobileTags } = useGetMobileTagsQuery();

	//Проверка на вывод стаба
	if (!mobileTags) {
		return <StubOperatorTariffs />;
	}

	return (
		<>
			{isMainSiteCode(siteCode) && <div></div>}
			{mobileTags?.length ? (
				<>
					<Container>
						<TagButtonComponent
							mobileTags={mobileTags}
							tagCode={params.tagCode}
							ratesMobile={true}
							operatorStyle={true}
							providerInetTvMobile={providerInetTvMobile}
							providerInetMobile={providerInetMobile}
						/>
					</Container>
					<Tariffs />
				</>
			) : (
				<Container>
					<EmptyStubWrapper
						headerText={text.NO_OPERATORS_HEADER}
						displayText={text.no_operator_info}
						buttonText={text.TO_MAIN_PAGE}
						iconHeader={"icon-balance"}
						iconButton={"icon-playlist-add"}
					/>
				</Container>
			)}
		</>
	);
};
